module.exports = __webpack_public_path__ + "static/media/Founders-Robotics-Plus.ccd5c9fd.jpg";